// src/main-wrapper/Routes.tsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Core Route Wrappers
import { PrivateRoute } from '../private-route';

// Page Components
import LenderLoginPage from '../features/auth/pages/login_flow/LenderLogin';
import ForgotPassword from '../features/auth/pages/forgot_password/ForgotPassword';
import ResetPasswordConfirmation from '../features/auth/pages/login_flow/ResetPasswordConfirmation';
import Dashboard from '../features/dashboard/Dashboard';
import Home from '../features/dashboard/Home';
import DealsLayout from '../features/deals/DealsLayout';
import ReportsPage from '../features/reports/ReportsPage';
import MainLayout from './MainContainer';
import DocumentsPage from '../features/documents/DocumentsPage'; // ✅ updated import
import Settings from '../features/settings/Settings';

function Main() {
  return (
    <Routes>
      {/* Public Login Route */}
      <Route path="/" element={<LenderLoginPage />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password-confirmation" element={<ResetPasswordConfirmation />} />

      {/* Protected App */}
      <Route element={<PrivateRoute />}>
        <Route element={<MainLayout />}>
          <Route path="/home" element={<Home />} />
          <Route path="/deals" element={<DealsLayout />} />
          {/* <Route path="/dashboard" element={<Dashboard />} /> */}
          {/* <Route path="/reports" element={<ReportsPage />} /> */}
          {/* <Route path="/upload" element={<DocumentsPage />} /> */}
          <Route path="/settings" element={<Settings />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default Main;
